<div class="d-flex">
  <input [(ngModel)]="amount" (ngModelChange)="onAmountChange()" clrInput />
  <select clrSelect [(ngModel)]="type" (ngModelChange)="onTypeChange()">
    <option value="days">days</option>
    <option value="weeks">weeks</option>
    <option value="months">months</option>
    <option value="years">years</option>
  </select>
</div>
